import React, { useEffect, useRef } from "react";

const MotorcycleMapCard = () => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    // Initialize Google Maps
    window.initMap = () => {
      mapInstanceRef.current = new window.google.maps.Map(mapRef.current, {
        center: { lat: 0, lng: 0 },
        zoom: 15,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        draggable: true,
        disableDefaultUI: true,
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
        ],
      });
    };

    const loadGoogleMaps = () => {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&callback=initMap`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    };

    // Internal function to update marker
    const updateMarkerInMapInternal = (locationDataString) => {
      console.log("updated marker in app entered");
      const locationData = JSON.parse(locationDataString);
      console.info("data converted from json");

      if (mapInstanceRef.current) {
        mapInstanceRef.current.panTo({
          lat: locationData.lat,
          lng: locationData.lng,
        });
      }

      if (markerRef.current) {
        markerRef.current.setPosition({
          lat: locationData.lat,
          lng: locationData.lng,
        });
        markerRef.current.setIcon({
          url: locationData.ignitionStatus
            ? "/ic_bike_green.png"
            : "/ic_bike_red.png",
          scaledSize: new window.google.maps.Size(44, 51),
        });
      } else {
        markerRef.current = new window.google.maps.Marker({
          position: { lat: locationData.lat, lng: locationData.lng },
          map: mapInstanceRef.current,
          title: "Motorcycle Location",
          icon: {
            url: locationData.ignitionStatus
              ? "/ic_bike_green.png"
              : "/ic_bike_red.png",
            scaledSize: new window.google.maps.Size(44, 51),
          },
        });
      }

      console.log("updated the marker in google maps");
      return "success";
    };

    // Set up window function for external updates
    window.updateMarkerInMap = updateMarkerInMapInternal;

    // Initialize map if Google Maps is already loaded
    if (!window.google) {
      loadGoogleMaps();
    } else {
      window.initMap();
    }

    // Cleanup function
    return () => {
      // Remove the window methods
      delete window.initMap;
      delete window.updateMarkerInMap;

      // Clear map instances
      mapInstanceRef.current = null;
      if (markerRef.current) {
        markerRef.current.setMap(null);
        markerRef.current = null;
      }
    };
  }, []); // Empty dependency array since we only want this to run once

  return (
    <div className="absolute top-0 left-0 w-full h-full">
      <div ref={mapRef} className="w-full h-full" />
    </div>
  );
};

export default MotorcycleMapCard;
